import { Component, Input } from '@angular/core';

@Component({
  selector: 'er-empty-state',
  template: `
    <div class="er-empty">
      <div class="er-empty__icon"><i [class]="icon" aria-hidden="true"></i></div>
      <div class="er-empty__title">{{ title }}</div>
      <div class="er-empty__msg" *ngIf="message">{{ message }}</div>
      <div class="er-empty__action"><ng-content></ng-content></div>
    </div>`
})
export class ErEmptyStateComponent {
  @Input() icon = 'fa fa-inbox';
  @Input() title = 'Nothing here yet';
  @Input() message: string | null | undefined;
}
